<template>
  <!-- 认证弹窗certification -->
  <div class="certification">
    <el-dialog
      title="忘记密码"
      width="366px"
      :visible.sync="dialogVisible"
      :before-close="handleClose"
      :close-on-click-modal="false"
    >
      <img src="../../assets/img/重置密码.png" alt="" />
      <el-form ref="form" :model="form" :rules="rules" label-width="80px">
        <el-form-item prop="LoginCode">
          <el-input
            v-model="form.LoginCode"
            @blur="blurPhone"
            placeholder="请输入手机号"
          ></el-input>
        </el-form-item>
        <!-- 邮箱 -->
        <el-form-item prop="MailBox">
          <el-input v-model="form.MailBox" placeholder="请输入邮箱"></el-input>
        </el-form-item>
        <!-- 验证码 -->
        <el-form-item prop="MailBoxVerificationCode">
          <el-input
            v-model="form.MailBoxVerificationCode"
            placeholder="请输入验证码"
          >
            <!-- <el-input v-model="form.MailBoxVerificationCode" placeholder="请输入登录密码"> -->
          </el-input>
          <p class="CheckMailbox">
            请登录邮箱查看验证码
          </p>
        </el-form-item>
        <el-button
          v-if="isshowMsgCode"
          class="code"
          :loading="loadingCode"
          @click="SendCode"
          >发送验证码</el-button
        >
        <div
          class="msg_btn"
          @click="handleMsgVCode"
          disabled
          v-if="!isshowMsgCode"
        >
          <span>{{ countTime }}秒后重新发送</span>
        </div>

        <el-form-item>
          <el-button type="primary" @click="NextStep" v-loading="loading"
            >下一步</el-button
          >
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
// 引入接口
import {
  SearchLoginCodeExistOrNot,
  GetMailBoxVerificationCode,
  GetVerificationCode,
  VerifyMailBoxVerificationCode
} from "@/api/user.js";
const TIME_COUNT = 60;
export default {
  name: "certification",
  props: {
    loginsInfo: {
      // 表格数据
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      // 表单数据
      form: {
        LoginCode: "",
        MailBox: "",
        MailBoxVerificationCode: ""
      },
      validation: {
        Phone: "",
        VerificationCode: ""
      },
      rules: {
        LoginCode: [
          { required: true, message: "请输入手机号", trigger: "blur" },
          {
            required: true,
            pattern: /^1[3456789]\d{9}$/,
            message: "手机号格式不正确",
            trigger: "blur"
          }
        ],
        MailBox: [{ required: true, message: "请输入邮箱", trigger: "blur" }]
      },
      // 倒计时
      isshowMsgCode: true,
      timer: null,
      countTime: "",
      // 单选按钮
      checked: false,
      loading: false,
      // 发送邮箱验证码 Loading
      loadingCode: false
    };
  },
  computed: {
    hasToken: {
      get() {
        return this.$store.state.users.token;
      }
    },
    userInfos: {
      get() {
        return this.$store.state.users.userInfo;
      }
    },
    dialogVisible: {
      get() {
        return this.loginsInfo.dialogVisible;
      },
      set(value) {
        this.$emit("update:visible", value);
      }
    },
    ResetPassword: {
      get() {
        return this.$store.state.users.ResetPassword;
      }
    }
  },
  methods: {
    blurPhone() {
      SearchLoginCodeExistOrNot(this.form).then(res => {
        console.log(res);
        if (res.Code === 0) {
          console.log(res.Data.MailBox);
          this.form.MailBox = JSON.parse(JSON.stringify(res.Data.MailBox));
          this.MailBox = JSON.parse(JSON.stringify(res.Data.MailBox));
          this.IsExist = res.Data.IsExist;
          if (!res.Data.IsExist) {
            this.$message({
              message: "该账号未注册",
              type: "warning"
            });
          } else if (
            res.Data.IsExist &&
            res.Data.MailBox == null &&
            res.Data.Phone !== ""
          ) {
            this.$message({
              message: "该账号未绑定邮箱",
              type: "warning"
            });
          }
        }
      });
    },
    handleConfirm() {
      // this.$refs.mychild.submitForm();
      // 触发父组件的方法 点击保存的方法
      this.$emit("confirm");
      this.$emit("update:visible", false);
    },
    handleCancel() {
      this.$emit("Cancel");
      this.$emit("update:visible", false);
    },
    handleClose() {
      this.isshowMsgCode = true;
      this.$refs["form"].resetFields();
      this.$emit("update:visible", false);
    },
    // 下一步
    NextStep() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          //如果通过验证 to do...
          this.form = {
            ...this.form,
            MailBoxVerificationCode: this.form.MailBoxVerificationCode
          };
          VerifyMailBoxVerificationCode(this.form)
            .then(res => {
              if (res.Code === 0) {
                this.$emit("getPhone", this.form.LoginCode);
                this.ResetPassword.dialogVisible = true;
                this.dialogVisible = false;
                this.$message({
                  message: res.Msg,
                  type: "success"
                });

                this.timer = null;
                this.isshowMsgCode = true;
                this.$refs["form"].resetFields();
                this.ResetPassword.dialogVisible = true;
                this.dialogVisible = false;
              }
            })
            .catch(err => {
              this.$emit("getPhone", this.form.LoginCode);
              console.log(err);
              this.$message({
                message: err,
                type: "warning"
              });
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 发送验证码
    SendCode() {
      console.log("发送验证码");
      this.$refs["form"].validate(valid => {
        if (valid) {
          // 输入得邮箱和返回得邮箱相同
          console.log(this.form.MailBox == this.MailBox);
          if (this.form.MailBox == this.MailBox) {
            if (this.IsExist) {
              // 发送邮箱验证 loading
              this.loadingCode = true;
              //如果通过验证 to do...
              this.SendData();
            } else {
              this.$message({
                message: "该手机号未注册",
                type: "warning"
              });
            }
          } else {
            // 不相同
            this.$message({
              message: "账号邮箱不匹配",
              type: "warning"
            });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 发送 验证请求
    // 发送验证码和数据
    SendData() {
      // 点击发送，清空验证码和手机号
      GetMailBoxVerificationCode(this.form)
        .then(res => {
          if (res.Code === 0) {
            this.$message({
              message: res.Msg,
              type: "success"
            });
            let countDownPhone = 59;
            if (!this.timer) {
              this.countTime = countDownPhone;
              this.isshowMsgCode = false;
              this.timer = setInterval(() => {
                if (this.countTime > 0 && this.countTime <= countDownPhone) {
                  this.countTime--;
                } else {
                  this.isshowMsgCode = true;
                  clearInterval(this.timer);
                  this.timer = null;
                }
              }, 1000);
            }
          }
        })
        .catch(err => {
          this.$message({
            message: err,
            type: "warning"
          });
        })
        .finally(() => {
          // 发送邮箱验证 loading
          this.loadingCode = false;
        });
    },
    // 读秒的时候提示
    handleMsgVCode() {
      this.$message({
        message: `${{ countTime }}后，再试`,
        type: "warning"
      });
    }
  },
  created() {
    this.isshowMsgCode = true;
  }
};
</script>

<style>
.messageIndex {
  margin-top: 80px;
  z-index: 9999 !important;
  /* // 设置的值一定要比2007大，因为dialog的层级是2007 */
}
.el-message {
  top: 20px !important;
}
.el-message:not(:last-child) {
  visibility: hidden;
}
</style>

<style lang="less" scoped>
.CheckMailbox {
  text-align: left;
  padding: 0px 30px;
  margin: 0px;
  color: #313131;
  width: 246px;
}
.el-dialog__body {
  padding: 10px 10px;
}
.ForgetPassword {
  text-align: right;
  height: 14px;
  font-size: 14px;
  font-family: Microsoft YaHei;
  font-weight: 400;
  color: #5b90f0;
}
/deep/ .messageIndex {
  z-index: 9999 !important;
  /* // 设置的值一定要比2007大，因为dialog的层级是2007 */
}
/deep/.el-dialog__header {
  padding: 65px 20px 10px;
}
/deep/.el-dialog {
  width: 366px;
  // height: 460px;
  background: #ffffff;
  border-radius: 10px;
}

.certification {
  position: relative;
  // background: url(../../assets/img/盾牌保险认证.png) no-repeat;
  // background-size: 20px 20px;
  // top: 0px;
  img {
    position: absolute;
    top: 68px;
    left: 120px;
  }
  .code {
    position: absolute;
    top: 305px;
    left: 200px;
  }
  .msg_btn {
    position: absolute;
    top: 310px;
    left: 200px;
  }
}
.certification /deep/.el-input__inner {
  // margin-bottom: 29px;
  background-color: #fff;
  border: none;
  border-radius: 1px;
  width: 266px;
  /* border: 1px solid #dcdfe6; */
  height: 60px;
  line-height: 60px;
  border-bottom: 1px solid #ebebeb;
}
.el-button--primary {
  width: 266px;
  height: 40px;
  background: #5b90f0;
  border: 1px solid #ebebeb;
  border-radius: 6px;
  text-align: center;
}
/deep/.el-form-item__content {
  margin: 0px 0px 0px !important;
}
.el-input__prefix,
.el-input__suffix {
  height: 0px !important;
}
// 错误提示
/deep/.el-form-item__error {
  position: absolute;
  top: 100%;
  left: 30px !important;
}
// 按钮上边距
.el-button--primary[data-v-35056f12] {
  margin-top: 10px !important;
}
// 复选框，选中
/deep/.el-checkbox__input.is-checked + .el-checkbox__label {
  color: #656565;
}
// 用户协议
.UserAgreement {
  cursor: pointer;
  color: #5b90f0;
}
</style>

<style scoped lang="less">
/deep/.el-dialog__header {
  border-bottom: none !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Dialog/ForgetPassword.vue